import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Job13y4jkazwjho0 as Job } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya3q1gard26whe6 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotActive_instanceavp2nits8goa as InternalReactiveNotActive_instance,
  InternalReactiveNotReady_instancer79hznuwejmn as InternalReactiveNotReady_instance,
  Companion_getInstance3byfqsk8b0ql6 as Companion_getInstance,
  _ReactiveState___init__impl__fvdp9b3rxdz1mjh763m as _ReactiveState___init__impl__fvdp9b,
} from '../core/ReactiveState.mjs';
import {
  equals2au1ep9vhcato as equals,
  setPropertiesToThrowableInstance1w2jjvl9y77yc as setPropertiesToThrowableInstance,
  captureStack1fzi4aczwc4hg as captureStack,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { DependencyChangeListener1518w8dt8yuu7 as DependencyChangeListener } from './DependencyChangeListener.mjs';
import { RawReactive253xb355brtjj as RawReactive } from '../core/signals.mjs';
import {
  onRemove3k528udkni1ni as onRemove,
  onThread26qoqfscmlcbk as onThread,
  Key_instancedbf5f19vpr99 as Key_instance,
} from './CalculationContext.mjs';
import {
  Exceptiondt2hlxn7j7vw as Exception,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { Reactive1jy75v4li6ldv as Reactive } from '../core/coreInterfaces.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
function endRun($this) {
  $this.job_1.cancel$default_8haxne_k$();
  $this.job_1 = Job();
}
function getOrLoading($this, $receiver) {
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
  var tmp0_subject = _ReactiveState___get_raw__impl__92ipya($receiver);
  var tmp;
  if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
    throw ReactiveLoading_getInstance();
  } else {
    if (equals(tmp0_subject, InternalReactiveNotActive_instance)) {
      throw ReactiveLoading_getInstance();
    } else {
      if (tmp0_subject instanceof InternalReactiveThrownException()) {
        throw _ReactiveState___get_raw__impl__92ipya($receiver).exception_1;
      } else {
        if (tmp0_subject instanceof InternalReactiveWrapper()) {
          tmp = _ReactiveState___get_raw__impl__92ipya($receiver).other_1;
        } else {
          tmp = _ReactiveState___get_raw__impl__92ipya($receiver);
        }
      }
    }
  }
  return tmp;
}
function TypedReactiveContext$startCalculation$ref(p0) {
  return constructCallableReference(() => {
    p0.startCalculation_tphsqx_k$();
    return Unit_instance;
  }, 0, 0, 7, 'startCalculation', [p0]);
}
var TypedReactiveContextClass;
function TypedReactiveContext() {
  if (TypedReactiveContextClass === VOID) {
    class $ extends DependencyChangeListener() {
      constructor(scope, useLastWhileLoading, reentrancyLimit, reportTo, action) {
        useLastWhileLoading = useLastWhileLoading === VOID ? false : useLastWhileLoading;
        reentrancyLimit = reentrancyLimit === VOID ? 0 : reentrancyLimit;
        reportTo = reportTo === VOID ? RawReactive().new_com_lightningkite_reactive_core_RawReactive_4h91ij_k$() : reportTo;
        super();
        this.scope_1 = scope;
        this.useLastWhileLoading_1 = useLastWhileLoading;
        this.reentrancyLimit_1 = reentrancyLimit;
        this.reportTo_1 = reportTo;
        this.action_1 = action;
        this.active_1 = false;
        var tmp = this;
        tmp.rerun_1 = TypedReactiveContext$startCalculation$ref(this);
        this.job_1 = Job();
        this.queued_1 = false;
        this.calculating_1 = false;
        onRemove(this.scope_1, () => {
          this.cancel_2l89ey_k$();
          return Unit_instance;
        });
      }
      get_coroutineContext_115oqo_k$() {
        return this.scope_1.get_coroutineContext_115oqo_k$().plus_s13ygv_k$(this.job_1).plus_s13ygv_k$(this);
      }
      startCalculation_tphsqx_k$() {
        this.active_1 = true;
        if (this.queued_1)
          return Unit_instance;
        this.queued_1 = true;
        if (this.calculating_1)
          return Unit_instance;
        endRun(this);
        onThread(this.scope_1, () => {
          var tmp;
          if (!this.active_1) {
            return Unit_instance;
          }
          var runs = 0;
          $l$loop: while (this.queued_1) {
            this.queued_1 = false;
            var _unary__edvuaz = runs;
            runs = _unary__edvuaz + 1 | 0;
            if (_unary__edvuaz > this.reentrancyLimit_1) {
              this.reportTo_1.set_state_wnfcx0_k$(Companion_getInstance().exception_iibuh2_k$(ReactiveReentrancyException().new_com_lightningkite_reactive_context_ReactiveReentrancyException_gto2ez_k$(this, this.reentrancyLimit_1)));
              break $l$loop;
            }
            try {
              this.calculating_1 = true;
              this.dependencyBlockStart_qxo3ow_k$();
              // Inline function 'com.lightningkite.reactive.core.reactiveState' call
              var tmp_0;
              try {
                var tmp$ret$1 = this.action_1(this);
                tmp_0 = _ReactiveState___init__impl__fvdp9b(tmp$ret$1);
              } catch ($p) {
                var tmp_1;
                if ($p instanceof CancellationException()) {
                  var e = $p;
                  throw e;
                } else {
                  if ($p instanceof ReactiveLoading()) {
                    var _unused_var__etf5q3 = $p;
                    tmp_1 = Companion_getInstance().notReady_1;
                  } else {
                    if ($p instanceof Exception()) {
                      var e_0 = $p;
                      tmp_1 = Companion_getInstance().exception_iibuh2_k$(e_0);
                    } else {
                      throw $p;
                    }
                  }
                }
                tmp_0 = tmp_1;
              }
              var state = tmp_0;
              var tmp_2;
              if (!this.useLastWhileLoading_1) {
                tmp_2 = true;
              } else {
                // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
                var tmp_3;
                // Inline function 'com.lightningkite.reactive.core.ReactiveState.active' call
                if (!equals(_ReactiveState___get_raw__impl__92ipya(state), InternalReactiveNotActive_instance)) {
                  tmp_3 = !equals(_ReactiveState___get_raw__impl__92ipya(state), InternalReactiveNotReady_instance);
                } else {
                  tmp_3 = false;
                }
                tmp_2 = tmp_3;
              }
              if (tmp_2) {
                this.reportTo_1.set_state_wnfcx0_k$(state);
              }
            }finally {
              this.dependencyBlockEnd_6wfk9j_k$();
              this.calculating_1 = false;
            }
            if (this.queued_1) {
              endRun(this);
            }
          }
          return Unit_instance;
        });
      }
      onDependencyChange_yaqozu_k$() {
        this.startCalculation_tphsqx_k$();
      }
      onDependencyNotReady_ntxysq_k$() {
        var tmp;
        if (!this.useLastWhileLoading_1) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
          var this_0 = this.get_state_wc71uu_k$();
          var tmp_0;
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.active' call
          if (!equals(_ReactiveState___get_raw__impl__92ipya(this_0), InternalReactiveNotActive_instance)) {
            tmp_0 = !equals(_ReactiveState___get_raw__impl__92ipya(this_0), InternalReactiveNotReady_instance);
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        if (tmp) {
          this.reportTo_1.set_state_wnfcx0_k$(Companion_getInstance().notReady_1);
        }
      }
      cancel_2l89ey_k$() {
        endRun(this);
        this.active_1 = false;
        this.queued_1 = false;
        super.cancel_2l89ey_k$();
      }
      use_rtup5c_k$(resourceUse) {
        if (!(this.existingDependency_tkmz95_k$(resourceUse) == null))
          return Unit_instance;
        this.registerDependency_23xa5k_k$(resourceUse, resourceUse.beginUse_omrbby_k$());
      }
      rerunOn_6homfr_k$(listenable) {
        if (!(this.existingDependency_tkmz95_k$(listenable) == null))
          return Unit_instance;
        this.registerDependency_23xa5k_k$(listenable, listenable.addListener_6y9mct_k$(this.rerun_1));
      }
      invoke_r7m7el_k$(_this__u8e3s4) {
        if (this.existingDependency_tkmz95_k$(_this__u8e3s4) == null) {
          this.registerDependency_23xa5k_k$(_this__u8e3s4, _this__u8e3s4.addListener_6y9mct_k$(this.rerun_1));
        }
        return getOrLoading(this, _this__u8e3s4.get_state_wc71uu_k$());
      }
      awaitNotNull_2lqt5h_k$(_this__u8e3s4) {
        if (this.existingDependency_tkmz95_k$(_this__u8e3s4) == null) {
          this.registerDependency_23xa5k_k$(_this__u8e3s4, _this__u8e3s4.addListener_6y9mct_k$(this.rerun_1));
        }
        var tmp0_elvis_lhs = getOrLoading(this, _this__u8e3s4.get_state_wc71uu_k$());
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw ReactiveLoading_getInstance();
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      state_a9mnra_k$(_this__u8e3s4) {
        if (this.existingDependency_tkmz95_k$(_this__u8e3s4) == null) {
          this.registerDependency_23xa5k_k$(_this__u8e3s4, _this__u8e3s4.addListener_6y9mct_k$(this.rerun_1));
        }
        return _this__u8e3s4.get_state_wc71uu_k$();
      }
      get_state_wc71uu_k$() {
        return this.reportTo_1.get_state_wc71uu_k$();
      }
      addListener_6y9mct_k$(listener) {
        return this.reportTo_1.addListener_6y9mct_k$(listener);
      }
      beginUse_omrbby_k$() {
        return this.reportTo_1.beginUse_omrbby_k$();
      }
    }
    initMetadataForClass($, 'TypedReactiveContext', VOID, VOID, [Reactive()]);
    TypedReactiveContextClass = $;
  }
  return TypedReactiveContextClass;
}
function reactive(_this__u8e3s4, reentrancyLimit, action) {
  reentrancyLimit = reentrancyLimit === VOID ? 0 : reentrancyLimit;
  var trc = new (TypedReactiveContext())(_this__u8e3s4, VOID, reentrancyLimit, VOID, action);
  trc.startCalculation_tphsqx_k$();
  var tmp0_safe_receiver = _this__u8e3s4.get_coroutineContext_115oqo_k$().get_y2st91_k$(Key_instance);
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver.watchBackgroundProcess_1utgjt_k$(trc);
  return trc;
}
var ReactiveLoadingClass;
function ReactiveLoading() {
  if (ReactiveLoadingClass === VOID) {
    class $ extends Error {
      constructor() {
        ReactiveLoading_instance = null;
        super(null);
        ReactiveLoading_instance = this;
        setPropertiesToThrowableInstance(this);
        captureStack(this, this.$throwableCtor_1);
      }
    }
    initMetadataForObject($, 'ReactiveLoading');
    ReactiveLoadingClass = $;
  }
  return ReactiveLoadingClass;
}
var ReactiveLoading_instance;
function ReactiveLoading_getInstance() {
  if (ReactiveLoading_instance === VOID)
    new (ReactiveLoading())();
  return ReactiveLoading_instance;
}
var ReactiveReentrancyExceptionClass;
function ReactiveReentrancyException() {
  if (ReactiveReentrancyExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      constructor(context, reentrancyLimit) {
        return new.target.new_com_lightningkite_reactive_context_ReactiveReentrancyException_gto2ez_k$(context, reentrancyLimit);
      }
      static new_com_lightningkite_reactive_context_ReactiveReentrancyException_gto2ez_k$(context, reentrancyLimit) {
        var $this = this.new_kotlin_IllegalStateException_w47ei6_k$(reentrancyLimit <= 0 ? 'A reactive calculation triggered its own re-execution (' + toString(context) + '). This usually means the ' + 'calculation wrote to a signal it also reads. Break the cycle so the calculation does not mutate its own dependencies. If it is instead meant to settle over several runs, raise reentrancyLimit to the number of reruns it needs.' : 'A reactive calculation kept triggering its own re-execution and did not settle within ' + ('its reentrancyLimit of ' + reentrancyLimit + ' reruns (' + toString(context) + '). Either it never ') + 'converges - every run changes a signal it reads, so there is no stable value to reach - or it genuinely needs a higher limit.');
        captureStack($this, $this.$throwableCtor_4);
        return $this;
      }
    }
    initMetadataForClass($, 'ReactiveReentrancyException');
    ReactiveReentrancyExceptionClass = $;
  }
  return ReactiveReentrancyExceptionClass;
}
function reactiveScope(_this__u8e3s4, action) {
  return reactive(_this__u8e3s4, VOID, action);
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  ReactiveLoading as ReactiveLoadings35224pps2d9,
  TypedReactiveContext as TypedReactiveContextwc1z7epz7cib,
  reactiveScope as reactiveScope1fcalsbdr0hgb,
  reactive as reactive2xic0rufq5s8n,
  ReactiveLoading_getInstance as ReactiveLoading_getInstance3l9yi71a4isfm,
};
//endregion

//# sourceMappingURL=ReactiveContext.mjs.map
